import {
  GET_ASSIGNED_APPOINTMENTS,
  GET_CONFIRMED_APPOINTMENTS,
  CONFIRM_APPOINTMENT,
  RESCHEDULE_APPOINTMENT,
  MOVE_BACK_QUEUE,
  GET_AVAILABLE_SLOTS,
  DOCTOR_ASSIGN,
  REMOVE_APPOINTMENT,
} from "../types/AssignedAppointmentTypes";

const initialState = {
  assigned: [], // Unconfirmed/booked appointments (left side)
  confirmed: [], // Confirmed appointments grouped by time slots (right side)
  availableSlots: [],
  summary: {}, 
  loading: false,
  error: null,
};

export default function AssignedAppointmentReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ASSIGNED_APPOINTMENTS:
      // Expecting action.payload to be an array of appointments
      return {
        ...state,
        assigned: Array.isArray(action.payload) ? action.payload : [],
        error: null,
      };

    // case GET_CONFIRMED_APPOINTMENTS:
    //   // Expecting action.payload to be an array of time slot objects with patients arrays
    //   return {
    //     ...state,
    //     confirmed: Array.isArray(action.payload) ? action.payload : [],
    //     summary: action.payload?.summary || {},
    //     error: null,
    //   };
    case GET_CONFIRMED_APPOINTMENTS:
      return {
        ...state,
        confirmed: Array.isArray(action.payload?.data)
          ? action.payload.data
          : [],
        summary: action.payload?.summary || {},
        error: null,
      };
    
    case CONFIRM_APPOINTMENT:
      // Remove the confirmed appointment from assigned list
      return {
        ...state,
        assigned: state.assigned.filter(
          (item) => item.appointment_id !== action.payload.appointment_id
        ),
      };

    case RESCHEDULE_APPOINTMENT:
      // Update the rescheduled appointment
      return {
        ...state,
        assigned: state.assigned.map((item) =>
          item.appointment_id === action.payload.appointment_id
            ? { ...item, ...action.payload }
            : item
        ),
      };

    case MOVE_BACK_QUEUE:
      // Remove from assigned
      return {
        ...state,
        assigned: state.assigned.filter(
          (item) => item.appointment_id !== action.payload
        ),
      };

    case REMOVE_APPOINTMENT:
      // Remove from assigned list
      return {
        ...state,
        assigned: state.assigned.filter(
          (item) => item.appointment_id !== action.payload
        ),
      };
      case GET_AVAILABLE_SLOTS:
        return {
          ...state,
          availableSlots: action.payload || [],
        };

    case DOCTOR_ASSIGN:
      // Remove assigned appointment from list
      return {
        ...state,
        assigned: state.assigned.filter(
          (item) => item.appointment_id !== action.payload.appointment_id
        ),
      };

    default:
      return state;
  }
}
